import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    taskId: String,
    tab: String
  }

  connect() {
    const finalUrl = new URL(this.urlValue, window.location.origin)
    finalUrl.searchParams.set('task_id', this.taskIdValue)
    if (this.tabValue) finalUrl.searchParams.set('tab', this.tabValue)

    window.location.href = finalUrl.toString()
  }
}
